var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import "../formatters/general";
import "../helpers/allowed_as_pod";
import _ from "../util/underscore_extensions";
import { DocumentBatchGroupCreator } from "./document_batch_group_creator";
import { UngroupedGroupCreator } from "./ungrouped_group_creator";
import { UngroupedGroupCopyCreator } from "./ungrouped_group_copy_creator";
import { GroupIDGroupCreator, DocumentBrowserUpdateNotifier } from "./group_id_group_creator";
function hasZeroPages(group) {
  return _.some(group.documents, ({ pages }) => pages.length === 0);
}
const doctypesAtTheStart = [
  "invoice",
  "rateConfirmation",
  "billOfLading",
  "deliveryReceipt",
  "customerRateCon"
];
const doctypesAtTheEnd = ["other"];
function doctypeGroupings(documents) {
  const documentTypes = _.groupBy(documents, (document) => document.type);
  const doctypeAtTheEndCompare = (a, b) => {
    const indexOfA = doctypesAtTheEnd.indexOf(a);
    const indexOfB = doctypesAtTheEnd.indexOf(b);
    if (indexOfA === -1 && indexOfB === -1) {
      return a.localeCompare(b);
    }
    if (indexOfA === -1) {
      return -1;
    }
    if (indexOfB === -1) {
      return 1;
    }
    return indexOfA - indexOfB;
  };
  return Object.keys(documentTypes).sort((a, b) => {
    const indexOfA = doctypesAtTheStart.indexOf(a);
    const indexOfB = doctypesAtTheStart.indexOf(b);
    if (indexOfA === -1 && indexOfB === -1) {
      return doctypeAtTheEndCompare(a, b);
    }
    if (indexOfA === -1) {
      return 1;
    }
    if (indexOfB === -1) {
      return -1;
    }
    return indexOfA - indexOfB;
  });
}
function GroupedDocumentBrowserModel(groupCreator, isCompl, initialPage) {
  const isComplete = isCompl || (() => false);
  const model = {
    _initialize: function() {
      this._createIndexes();
      this._selectInitialPage();
    },
    _pagesByParentId: {},
    _groupsByDocumentId: {},
    _documentsByPageId: {},
    _createIndexes: function() {
      this.groups.forEach((g) => {
        g.documents.forEach((d) => {
          this._groupsByDocumentId[d.id] = g;
          d.pages.forEach((p) => {
            this._documentsByPageId[p.id] = d;
            if (p.parent_id) {
              this._pagesByParentId[p.parent_id] = p;
            }
          });
        });
      });
    },
    _selectInitialPage: function() {
      if (initialPage && this._documentForPage(initialPage)) {
        this.selectPage(initialPage);
      } else if (initialPage && this._pageForParentId(initialPage.id)) {
        this.selectPage(this._pageForParentId(initialPage.id));
      } else {
        this._selectDefaultPage();
      }
    },
    _pageForParentId: function(pageId) {
      return this._pagesByParentId[pageId];
    },
    _selectDefaultPage: function() {
      if (_.some(this.groups, hasZeroPages)) {
        this.selectedPage = void 0;
        this.selectedGroup = void 0;
        return;
      }
      _.find(this.groups, function(group) {
        const doc = _.find(group.documents, function(d) {
          return !isComplete(d);
        });
        if (doc && doc.pages.length) {
          this.selectPage(doc.pages[0]);
        }
        return doc;
      }.bind(this));
      if (!this.selectedGroup && this.groups.length > 0) {
        this.selectPage(this.groups[0].documents[0].pages[0]);
      }
    },
    _documentForPage: function(page) {
      return this._documentsByPageId[page.id] || _.findWhere(this.allDocuments(), { id: page.document_id });
    },
    _groupForDocument: function(doc) {
      return this._groupsByDocumentId[doc.id] || this.selectedGroup;
    },
    selectNextPageMatchingRule(pageFunction) {
      const formatPage = (d, p) => __spreadValues({
        type: d.type
      }, p);
      const docs = this.activeDocuments();
      const pages = _.flatten(_.map(docs, (d) => _.flatten(_.map(d.pages, (p) => {
        return formatPage(d, p);
      }))));
      const pos = _.map(pages, (p) => p.id).indexOf(this.selectedPage.id);
      const pageFinder = function(inPages) {
        return _.find(inPages, (p) => pageFunction(p));
      };
      let match = pageFinder(pages.slice(pos + 1, pages.length));
      if (!match) {
        match = pageFinder(pages.slice(0, pos));
      }
      if (match) {
        this.selectPage(match);
      }
    },
    selectPage: function(page) {
      this._sequence = _.now();
      if (page) {
        this.selectedPage = page;
      } else {
        this._selectDefaultPage();
      }
      this.selectedDocument = this._documentForPage(this.selectedPage);
      this.selectedGroup = this._groupForDocument(this.selectedDocument);
      groupCreator.groupSelected(this.selectedGroup, this.groups);
      $(this).trigger("document-browser-model:page-selected");
    },
    groups: groupCreator.groups,
    allGroups: groupCreator.allGroups,
    groupCreator,
    activeDocuments: function() {
      const documents = _.flatten(_.pluck(_.where(this.groups, { selected: true }), "documents"));
      if (!Auth._currentUser.account.settings.documents_viewer_doctype_grouping_enabled) {
        return documents;
      }
      const documentTypes = _.groupBy(documents, (document) => document.type);
      return doctypeGroupings(documents).flatMap((doctype) => {
        return documentTypes[doctype].sort((a, b) => a.id - b.id);
      });
    },
    allDocuments: function() {
      const relatedDocuments = _.flatten(_.pluck(this.groups, "relatedDocuments"));
      const documents = _.flatten(_.pluck(this.groups, "documents"));
      return _.compact(relatedDocuments.concat(documents));
    },
    incompleteDocuments: function() {
      return _.reject(this.activeDocuments(), isComplete);
    },
    indexerGroups: function() {
      return _.reject(this.groups, function(group) {
        const finished = _.all(group.documents, _.property("finished"));
        const assignedToCarrierInvoice = _.all(group.documents, (document) => {
          return !_.isNull(document.carrier_invoice_id);
        });
        return finished || assignedToCarrierInvoice;
      });
    },
    incompleteGroups: function() {
      return _.reject(this.groups, function(group) {
        return _.all(group.documents, _.property("finished"));
      });
    },
    nextIncompleteDocument: function() {
      const docs = this.activeDocuments();
      const pos = docs.indexOf(this.selectedDocument);
      const after = _.find(docs.slice(pos + 1, docs.length), (d) => !isComplete(d));
      if (after) {
        return after;
      }
      const before = _.find(docs.slice(0, pos), (d) => !isComplete(d));
      if (before) {
        return before;
      }
    },
    previousDocument: function() {
      const docs = this.activeDocuments();
      const pos = docs.indexOf(this.selectedDocument);
      if (pos > 0) {
        return docs[pos - 1];
      }
    },
    nextDocument: function() {
      const docs = this.activeDocuments();
      const pos = docs.indexOf(this.selectedDocument);
      if (pos < docs.length - 1) {
        return docs[pos + 1];
      }
    },
    nextPageInGroup: function() {
      if (this.selectedPage !== _.last(this.selectedDocument.pages)) {
        const position = this.selectedDocument.pages.indexOf(this.selectedPage);
        return this.selectedDocument.pages[position + 1];
      } else if (this.nextDocument()) {
        return _.first(this.nextDocument().pages);
      }
      return null;
    },
    factoringAssignment: function() {
      return _.find(this.activeDocuments(), function(d) {
        return d.type === "factoringAssignment";
      });
    },
    invoice: function() {
      return _.find(this.activeDocuments(), function(d) {
        return d.type === "invoice" || d.data.actsAsInvoice;
      });
    }
  };
  model._initialize();
  return model;
}
;
export {
  doctypeGroupings,
  GroupedDocumentBrowserModel,
  GroupIDGroupCreator,
  DocumentBatchGroupCreator,
  UngroupedGroupCreator,
  UngroupedGroupCopyCreator,
  DocumentBrowserUpdateNotifier
};
